import React from 'react'
import PropTypes from 'prop-types'
import { hasLocizeTranslation } from 'lib/utils/locize'
import Typo from 'constants/typography'
import ToggleView from 'components/common/toggle-view'
import styles from './styles.scss'

const SizesGuidesUnits = ({ unit, onClick, t }) => (
  <div className="sizes-guide-units">
    <style jsx>{styles}</style>
    <div className="sizes-guide-units__container">
      <ToggleView
        onChange={onClick}
        value={unit}
        options={[
          {
            component: (
              <span className={Typo.button}>
                {hasLocizeTranslation(t, 'PDP__SIZE_UNIT_IN', 'IN')}
              </span>
            ),
            value: 'in',
          },
          {
            component: (
              <span className={Typo.button}>
                {hasLocizeTranslation(t, 'PDP__SIZE_UNIT_CM', 'CM')}
              </span>
            ),
            value: 'cm',
          },
        ]}
      />
    </div>
  </div>
)

SizesGuidesUnits.defaultProps = {
  unit: 'in',
}

SizesGuidesUnits.propTypes = {
  unit: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default SizesGuidesUnits
